"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EncryptionMode = exports.defaultConfigMonitor = exports.PluginOffsetByte = exports.LOCAL_CONFIG_MAX_AGE = exports.CONFIT_STORAGE_PREFIX = exports.API_ERROR_CODE = exports.apiMaps = exports.API_PREFIX = exports.host = void 0;
/**
 * 对于接入方，只提供 exp(nonlive) 与live环境
 * 非live环境的数据均上报到exp环境中
 * SDK内部测试环境上报由reportHost控制
 */
exports.host = {
    live: 'https://dem.shopee.com',
    test: 'https://dem.exp.shopee.io',
    staging: 'https://dem.exp.shopee.io',
    uat: 'https://dem.exp.shopee.io',
    mock: 'https://api.seller.shopee.io/mock/1900'
};
exports.API_PREFIX = '/dem/entrance/v1/apps';
exports.apiMaps = {
    login: '/dem/janus/v1/app-auth/login'
};
exports.API_ERROR_CODE = {
    INVALID_ARGUMENT: 400000,
    INVALID_CONTENT_TYPE: 400001,
    INVALID_FILE: 400010,
    UNAUTHORIZED_TOKEN: 401000,
    TOKEN_EXPIRED: 401001,
    PERMISSION_DENIED: 403000,
    // INTERNAL_SERVER_ERROR: 500,
};
exports.CONFIT_STORAGE_PREFIX = 'MDAP_CONFIG_STORAGE';
exports.LOCAL_CONFIG_MAX_AGE = 3600 * 1000 * 24;
/**
 * https://confluence.shopee.io/pages/viewpage.action?pageId=765038734#id-1.1.2.1MDAPWEBSDK%E8%AE%BE%E8%AE%A1-2.3.3.PluginOffsetByteMapping
 */
exports.PluginOffsetByte = {
    'api': 1 << 0,
    'resource': 1 << 1,
    'navigation': 1 << 2,
    'customized': 1 << 3,
    'exception': 1 << 4
};
exports.defaultConfigMonitor = {
    platform: 'Web',
    status: 0,
    is_vip: 0,
    invoke_tasks: 0,
    enable_tasks: 0,
    install_tasks: 0,
    used_config: '',
    extra_info: ''
};
exports.EncryptionMode = {
    PLAIN: 0,
    CIPHER: 1,
    /* encrypt report data except whitelist-users */
    CIPHER_EXCEPT_WHITELIST: 2
};
